/*eslint-disable */

import pwChangedSuccessfullyPopup from '@/components/private/user/pw-changed-successfully-popup/';
import toast from '@/services/toast';

export default {
  name: 'create-new-password',
  components: {
    'pw-changed-popup' : pwChangedSuccessfullyPopup
  },
  props: ['identityU'],
  data () {
    return {
      submitted:false,
      password:'',
      confirm_password:'',
      pwChangedSuccessState:false,
      has_number:false,
      has_lowercase:false,
      has_uppercase:false,
      has_special:false,
      showPassword:false
    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {
    passwordValidatorMethod(){
        this.has_number = /\d/.test(this.password);
        this.has_lowercase = /[a-z]/.test(this.password);
        this.has_uppercase = /[A-Z]/.test(this.password);
        this.has_special = /[#?!@$%^&*-]/.test(this.password);
        this.password = this.password.replace(/\s/g,'')
    },
    validateBeforeSubmit(){
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true;
          this.$store.dispatch('createNewPwOfAuthApiAction', {
            identity: this.identityU,
            password: this.confirm_password
          })
            .then((res) => {
              this.pwChangedSuccessState = true
              toast.success(res.data.msg);
            }).catch((err) => {
              this.submitted = false
            })
          return;
        }
      });
    },
  }
}


